import React, { memo, Fragment } from "react";
import { Grid, TextField, MenuItem, Divider } from "@mui/material";
import { editTier, selectTierById } from "./tiersSlice";
import { useDispatch, useSelector } from "react-redux";

const WrappedComponent = ({ id }) => {
	const dispatch = useDispatch();
	const tier = useSelector(state => selectTierById(state, id));
	const fields = [
		{label: "Current Product", value: tier.product, field: "product", xs: 6, select: true, options: [
			"Conventional", "SBA 7(a)", "SBA 504", "USDA", "Other"
		]},
		{label: "Other Product?", value: tier.otherProduct, field: "otherProduct", xs: 6, select: false},
		{label: "Current Rate", value: tier.rate, field: "rate", xs: 6, select: false},
		{label: "ARM?", value: tier.arm, field: "arm", xs: 6, select: true, options: ["Yes", "No"]},
		{label: "Term Before ARM in yr(s)", value: tier.termBefore, field: "termBefore", xs: 6, select: false},
		{label: "Rate after ARM", value: tier.termAfter, field: "termAfter", xs: 6, select: false},
		{label: "Term Remaining Yr(s)", value: tier.termRemaining, field: "termRemaining", xs: 6, select: false},
		{label: "Creditworthiness", value: tier.credit, field: "credit", xs: 6, select: true, options: [
			"Excellent", "Good", "Average", "Fair", "Poor"
		]},
		{label: "Debt Remaining", value: tier.debt, field: "debt", xs: 6, select: true, options: [
			"<$1M", "$1M-$2.5M", "$2.5M-$5M", "$5M-$10M", ">$10M"
		]},
		{label: "Current Equity", value: tier.equity, field: "equity", xs: 6, select: true, options: [
			"<$1M", "$1M-$2.5M", "$2.5M-$5M", "$5M-$10M", ">$10M"
		]}
	]

	const onChange = (e, field) => {
		if(field === "arm" && e.target.value !== "Yes") {
			dispatch(editTier({id, changes: {termBefore: "", termAfter: ""}}));
		}
		if(field === "product" && e.target.value !== "Other") {
			dispatch(editTier({id, changes: {otherProduct: ""}}));
		}
		dispatch(editTier({id, changes: {[field]: e.target.value}}));
	};

	const SelectProps = {
		MenuProps: {
			disableScrollLock: true
		}
	};

	return (
		<Grid container spacing={2}>
			{fields.map(({label, value, select, field, xs, options}, key) =>
				<Fragment key={`tier_${id}_field_${field}_${key}`}>
					<Grid item {...{xs}}>
						<TextField
							{...{label, value, select, SelectProps}}
							disabled={((field === "otherProduct" && tier.product !== "Other") || ((field === "termBefore" || field === "termAfter") && tier.arm !== "Yes"))}
							inputProps={{
								maxLength: field === "termRemaining" ? 2 : 99
							}}
							InputLabelProps={{
								sx: {
									fontSize: field === "termRemaining" ? ".85rem" : field === "termBefore" ? ".75rem" : "1rem",
									"&.MuiInputLabel-shrink": {
										fontSize: "1rem",
										lineHeight: "inherit"
									},
									lineHeight: field === "termBefore" ? "2em" : "inherit"
								}
							}}
							fullWidth
							size="small"
							onChange={(e) => onChange(e, field)}
						>
							{!!options && options.map((value, key) =>
								<MenuItem key={`tier_${id}_${field}_option_${key}`} {...{value}}>{value}</MenuItem>
							)}
						</TextField>
					</Grid>
					{field === "arm" && <Divider textAlign="left" sx={{flexBasis: "100%", alignItems: "flex-start", pt: 2, pl: 2}}>If ARM:</Divider>}
				</Fragment>
			)}
		</Grid>
	);
};

export const Tier = memo(WrappedComponent);